import * as React from "react";
import { Spin } from "antd";

interface ITableStatisticsProps {
  statisticsInfo: any;
  isLoading: any;
  className?: any;
}

// 表格统计
class TableStatistics extends React.Component<ITableStatisticsProps, any> {
  constructor(props: ITableStatisticsProps) {
    super(props);
  }

  // 获取统计信息
  getStatistics = () => {
    const statisInfo = this.props.statisticsInfo;
    let list: any = [];
    for (let i = 0; i < statisInfo.length; i++) {
      list.push(
        <span key={i} className="static-item">
          <label>{statisInfo[i].name}:</label>
          <span className="statis-num">{statisInfo[i].id}</span>
        </span>
      );
    }
    return list;
  };

  getClassName = () => {
    return "table-statis " + (this.props.className || "");
  };

  render() {
    return (
      <div className={this.getClassName()}>
        <Spin spinning={this.props.isLoading} />
        {this.getStatistics()}
      </div>
    );
  }
}

export default TableStatistics;
